import { white } from "assets/styleUtils";
import useModal from "hooks/useModal";
import { AnimatedModal } from "modal";
import { ReactNode } from "react";
import { useRecoilValue } from "recoil";
import { modalState } from "recoil/modal";

export default function ModalContainer({ children }: { children: ReactNode }) {
  const { removeModal } = useModal();
  const modals = useRecoilValue(modalState);

  return (
    <>
      {children}
      {modals.map(
        ({
          modalchildren: modalChildren,
          id,
          backdropRemove = true,
          ...restProps
        }) => (
          <AnimatedModal
            key={id}
            close={() => backdropRemove && removeModal(id)}
            backdropRemove={backdropRemove}
            {...restProps}
          >
            {modalChildren}
          </AnimatedModal>
        )
      )}
    </>
  );
}
